<template>
  <div class="list-wrapper" v-if="material">
    <div class="search-wrapper d-flex m-b-20 align-items-center">
      <div style="flex:1;" class=" d-flex align-items-center">
        <el-button size="small" class="me-3" v-if="is_edit" @click="onSelAll">全选</el-button>
        <el-select v-model="searchData.category" placeholder="请选择" size="small" @change="claerPage" v-if="typeList && typeList.length > 0">
          <el-option
            v-for="item in typeList"
            :key="item.index"
            :label="item.title"
            :value="item.id"
          >
          <div class=" d-flex align-items-center">
            <div style="flex:1;">{{item.title}}{{item.total > 0 ? `(${item.total})` : ''}}</div>
            <i class="el-icon-edit me-3" v-if="item.id > 0" @click.stop="onEditType(item)"></i>
            <i class="el-icon-delete" v-if="item.id > 0" @click.stop="onRemoveType(item)"></i>
          </div>
          </el-option>
        </el-select>
        <el-button size="small" v-if="!is_edit" @click="onShowInp" class="ms-1" icon="el-icon-circle-plus"></el-button>
      </div>
      <el-button size="small" @click="edit_category_drawer = true" :disabled="checkList.length <= 0" v-if="is_edit" type="success" icon="el-icon-rank">移动到</el-button>
      <el-button size="small" @click="onDels" v-if="is_edit" type="primary" :disabled="checkList.length <= 0" icon="el-icon-delete-solid">删除</el-button>
      <el-button size="small" @click="onCloseEdit" v-if="is_edit">取消</el-button>
      <el-button size="small" @click="is_edit = true" v-if="!is_edit">批量操作</el-button>
      <el-button @click="drawer = true" size="small" icon="el-icon-upload" type="primary" v-if="!is_edit">本地上传</el-button>
    </div>

    <!-- 添加分组 -->
    <el-dialog
      :title="edit_type_id ? '修改分组' : '添加分组'"
      :visible.sync="type_drawer"
      width="30%"
      center>
      <el-input
        placeholder="请输入素材分组名称"
        v-model="type_text"
        maxlength="10"
        show-word-limit
        clearable>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="type_drawer = false" size="small">取 消</el-button>
        <el-button type="primary" v-if="!edit_type_id" @click="onAddType" :disabled="type_text == ''" size="small">添 加</el-button>
        <el-button type="primary" v-if="edit_type_id" @click="onEditTypeConfirm" :disabled="type_text == ''" size="small">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 修改素材分组 -->
    <el-dialog
      title="修改素材分组"
      :visible.sync="edit_category_drawer"
      width="30%"
      center>
      <el-select v-model="edit_category" placeholder="请选择" size="small" @change="claerPage" class=" w-100">
        <el-option
          v-for="item in typeList"
          :key="item.index"
          :label="item.title"
          :value="item.id"
          v-if="item.id >= 0">
        <div class=" d-flex align-items-center">
          <div style="flex:1;">{{item.title}}</div>
        </div>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_category_drawer = false" size="small">取 消</el-button>
        <el-button type="primary" @click="onEditCategory" :disabled="edit_category === ''" size="small">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 素材库 -->
    <el-drawer
      title="素材库"
      :visible="drawer"
      class="materual-wrappers" 
      direction="rtl"
      size="500px"
      :close-on-press-escape="true"
      :wrapperClosable="true"
      :before-close="handleClose"
    >
      <materials @onImgsSubmit="pushImg"></materials>
    </el-drawer>

    <div class="list" v-show="is_edit">
      <el-checkbox-group v-model="checkList">
        <el-row :gutter="20">
          <el-col
            :span="4"
            v-for="img in material.list"
            :key="img.index"
            class="img-min position-relative"
          >
            <el-checkbox :label="img.id" :name="`img-${img.id}`" class=" position-absolute start-0 top-0 end-0 bottom-0 m-0" style="z-index:111;">&nbsp;</el-checkbox>
            <div
              class=" ratio ratio-1x1 position-relative"
              :id="`img-${img.id}`"
            >
              <img
                :src="addImageSuffix(img.url, 'small-2x')"
                fit="cover"
                :alt="img.title"
                :title="img.title"
              />
              <div class="fs-10 position-absolute bottom-0 w-100 font-line-1 text-center p-1 bg-white bg-opacity-50" style="height:25px;top:auto;" v-if="img.category_obj.name">
                {{img.category_obj.name}}
              </div>
            </div>
            <div class="title">
              <div class=" fs-10 my-2 text-center font-line-1">{{ img.title }}</div>
            </div>
          </el-col>
          
        </el-row>
      </el-checkbox-group>
    </div>

    <div class="list" v-if="!is_edit">
        <el-row :gutter="20">
          <el-col
            :span="4"
            v-for="(img, index) in material.list"
            :key="img.index"
            class="img-min position-relative"
          >
            <div
              class="poster"
            >
              <el-image
                :src="addImageSuffix(img.url, 'middle')"
                :preview-src-list="material.srcList"
                :initial-index="index"
                fit="cover"
                :alt="img.title"
                :title="img.title"
                placeholder="加载中..."
                error="图片已失效"
              >
              </el-image>
              <div class="position-absolute bottom-0 w-100 bg-white text-center bg-opacity-50 p-1 fs-10 font-line-1" v-if="img.category_obj.name">
                {{img.category_obj.name}}
              </div>
            </div>
            <div class="title">
              <div class=" fs-10 my-2 text-center font-line-1">{{ img.title }}</div>
              <div class=" d-flex justify-content-center">
                <el-button type="text" class=" p-0 text-muted fs-10" @click="$refs.MaterialInfo.open(img)">编辑</el-button>
                <el-button type="text" class=" p-0 text-muted fs-10" @click.stop="del(img, index)">删除</el-button>
              </div>
            </div>
          </el-col>
          
        </el-row>
    </div>

    <div v-if="material && material.total > 0" class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="material.total"
        :page-size="18"
        :current-page="searchData.page"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>
    <el-empty description="暂无素材" v-if="material.list && material.total <= 0"></el-empty>

    <material-info ref="MaterialInfo" :typeList="typeList" @onConfirm="material.getList(searchData)"></material-info>
  </div>

</template>
<script>
import { Material } from "@/lib/material/index.js";
import Materials from "@/components/material/upload";
import MaterialDepositoryService from '../../service/MaterialDepository.service.js'
import MaterialInfo from './info.vue'
import {addImageSuffix} from '../../utils/aliyun'
export default {
  data() {
    return {
      material: null,
      searchData: {
        page: this.$route.query.page * 1 || 1,
        search: undefined,
        category: this.$route.query.category * 1 || -1,
      },
      date: [],
      typeList: [],
      drawer: false,
      checkList: [],
      is_edit: false,
      type_drawer: false,
      type_text: '',
      edit_type_id: undefined,
      edit_category: '',
      edit_category_drawer: false
    };
  },
  components: {
    Materials,
    MaterialInfo
  },
  created() {
    this.getType()
    this.material = new Material(this.searchData);
  },
  methods: {
    addImageSuffix,
    onEditTitle(img) {
      this.material.editTitle(img);
    },
    onTabClick(e) {
      this.searchData.page = 1;
    },
    del(img, index) {
      this.material.del(img, index);
      this.material.getList(this.searchData);
    },
    pageChange(e) {
      this.searchData.page = e;
    },
    handleClose(done) {
      this.drawer = false;
      this.type_drawer = false
    },
    // 图片上传成功
    pushImg(list) {
      this.material.getList(this.searchData);
      this.handleClose();
    },
    claerPage () {
      this.searchData.page = 1
    },
    onCloseEdit () {
      this.is_edit = false
      this.checkList = []
    },
    onSelAll () {
      if (this.checkList.length < this.material.list.length) {
        this.checkList = this.material.list.map(item => {
          return item.id
        })
      } else {
        this.checkList = []
      }
    },
    onAddType () {
      MaterialDepositoryService.addType({title: this.type_text, weight: 0}).then(res => {
         this.$message.success("添加成功！");
         this.getType()
         this.type_text = ''
         this.type_drawer = false
      })
    },
    onEditTypeConfirm () {
      MaterialDepositoryService.editType({id: this.edit_type_id, title: this.type_text, weight: 0}).then(res => {
         this.$message.success("修改成功！");
         this.getType()
         this.type_text = ''
         this.type_drawer = false
      })
    },
    getType () {
       MaterialDepositoryService.getTypeList({size:1000}).then(res => {
        this.typeList = [...res.results]
      })
    },
    onRemoveType (item) {
      this.$confirm('确认删除该素材分组！', "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        MaterialDepositoryService.delType(item).then(res => {
          this.$message.success("删除成功！");
          this.getType()
        })
      })
    },
    onEditType (item) {
      this.edit_type_id = item.id
      this.type_text = item.title
      this.type_drawer = true
    },
    onShowInp () {
      this.edit_type_id = undefined
      this.type_text = ''
      this.type_drawer = true
    },
    onDels () {
      if (this.checkList.length > 0) {
        MaterialDepositoryService.dels({ids: this.checkList}).then(res => {
          this.$message.success("删除成功！")
          this.getType()
          this.material.getList(this.searchData)
        })
      }
    },
    onEditCategory () {
      MaterialDepositoryService.setcategory({ids: this.checkList, category: this.edit_category}).then(res => {
        this.$message.success("修改成功！")
        this.material.getList(this.searchData)
        this.checkList = []
        this.edit_category_drawer = false
      })
    }
  },
  watch: {
    searchData: {
      handler(newVal, oldVal) {
        this.checkList = []
        this.$router.push({ path: '/material', query: newVal }, () => {this.material.getList(newVal)})
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.img-min {
  overflow: hidden;
  margin-bottom: 15px;
  .poster {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
    .el-image {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .transition-box {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      background: rgba($color: #666666, $alpha: 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
  }
  .title {
    width: 100%;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>